import { render } from "./Results.vue?vue&type=template&id=db8ef5e4&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=db8ef5e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8ef5e4"]])

export default __exports__